import React from 'lib/react';
import { Route } from 'lib/router';
import PropTypes from 'prop-types';
import { useSelector } from 'lib/redux';
import TitleHeader from 'commonComponents/titleHeader';
import { getTitleHeaderProps } from 'utils/app.utils';
import { isMultiplePaymentMethodsEnabledSelector } from 'utils/appSelectors.utils'; // #genai
import { makeStyles } from 'lib/components';
import Authorize from 'features/authorize';
import { isAuthorized, isEntitled } from './utils/auth.utils';

const useStyles = makeStyles((theme) => ({
  main: {
    backgroundColor: theme.evPalette.charcoal[100],
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
}));

/**
 * Component that ensures that the specific routes are not accessible by unauthorized users
 */
function PrivateRoute({ component: Component, ...rest }) {
  const classes = useStyles();
  const entitlements = useSelector(({ userEntitlements }) => userEntitlements);
  // #genai Phase 2: flips the /billing-information TitleHeader label to "Payment Methods (Billing)".
  const isPhase2Active = useSelector(isMultiplePaymentMethodsEnabledSelector);

  const isAuthorizedAndEntitled = () => (isAuthorized() && isEntitled(entitlements));

  const render = (params) => {
    const { match: { path } } = params;
    const titleHeaderProps = getTitleHeaderProps(path, isPhase2Active);

    if (isAuthorizedAndEntitled()) {
      return (
        <>
          {titleHeaderProps && <TitleHeader {...titleHeaderProps} />}
          <main id="main" className={classes.main}>
            <Component {...params} />
          </main>
        </>
      );
    }

    return <Authorize />;
  };

  return (
    <Route
      {...rest}
      render={render}
    />
  );
}

PrivateRoute.propTypes = {
  /**
   * @property {element or Component} - Element or component to be displayed by the Route
   */
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
};

export default PrivateRoute;
